import { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";

import { Container } from "style/admin/contents";
import { AdminCalibrationTable } from "components/admin/contents/calibration/admin.calibration.table";
import { CalibrationReadParams, CalibrationReadDto } from "interface/admin/interface.calibration";
import { calibrationDeleteTriggerState } from "atoms/admin/contents/calibration.state";
import { fetchLoadAdminCalibration } from "api/admin/contents.calibration";

export function AdminCalibrationHome() {
  const [data, setData] = useState<CalibrationReadDto[]>([]);
  const calibrationDeleteTrigger = useRecoilValue(calibrationDeleteTriggerState);

  useEffect(() => {
    const loadCalibrationList = async () => {
      const params: CalibrationReadParams = {
        orderBy: "created_at",
        orderByDir: "desc",
        offset: 0,
        pageSize: 100,
      };
      const response = await fetchLoadAdminCalibration(params);
      if (response.result) {
        setData(response.result);
      }
    };
    loadCalibrationList();
  }, [calibrationDeleteTrigger]);

  return (
    <Container>
      <AdminCalibrationTable data={data} />
    </Container>
  );
}
